module.exports = __webpack_public_path__ + "static/media/ManyUsers_PDF@1x.bda740a3.png";